import React, { useContext } from "react";
import DefaultForm from "../../form";
import { AppContext } from "../../../context/appContext";
import { createUserMessage, isEmpty } from "../../../utils";
import { BotBubble } from "./chatBubbles";

type TProps = {
  // message: any;
  // page: any;
  payload: any;
  setState: (val: any) => void;
  actions: {
    sendUserWsMessage: (message: string) => void;
  }
}

const addChatUserMessage = ({chatUserMessage, setState}: any) => {
  const userMessageObject = {
    id: `user-${Date.now()}`,
    message: chatUserMessage,
    type: "user",
  };

  setState((prevState: any) => ({
    ...prevState,
    messages: [...prevState.messages, userMessageObject],
  }));
}

function ChatForm(props: TProps) {
  const {
    setState,
    payload: {page}, 
    actions: {sendUserWsMessage}
  } = props;
  
  const {widgetConfig} = useContext(AppContext)

  return (
    page?.id && 
      <div className="react-chatbot-kit-chat-bot-form-container flex">
        <BotBubble>
          <div className="message-title">{widgetConfig.participants.bot?.name || 'Bot'}</div>
          <div className="chat-form-container !block">
            <div className="chat-form-title message-text">{page.title}</div>
            {page.explanation && <div className="chat-form-explanation message-text">{page.explanation}</div>}
            {!!page.elements.length &&
              <DefaultForm 
                config={page.elements} 
                onSubmit={(value) => {
                  console.log('value', Object.values(value)[0])
                  if (!isEmpty(value)) {
                    const [chatUserMessage, wsUserMessage] = createUserMessage({value, page});
                    addChatUserMessage({chatUserMessage, setState});
                    sendUserWsMessage(wsUserMessage);
                  }
                }}
                ButtonsComponent={({formState:{isDirty, isValid }}: any) => (
                  <button className="form-button submit-button" disabled={!isDirty || !isValid} type="submit">Confirm</button>
                )}
              />
            }
          </div>
        </BotBubble>
      </div>
  )
};

export default ChatForm;
